import type { ApiClient } from "../../api";
import {
  getApiV1SystemBuild,
  getApiV1SystemOutboxHealth,
  getApiV1SystemQueueHealth,
  getApiV1SystemReadiness,
  postApiV1SystemTestEvent,
  postApiV1SystemTestNotification,
} from "../../api/generated";

export class OperationsApi {
  constructor(private readonly client: ApiClient) {}

  build() {
    return getApiV1SystemBuild(this.client);
  }

  readiness() {
    return getApiV1SystemReadiness(this.client);
  }

  queueHealth() {
    return getApiV1SystemQueueHealth(this.client);
  }

  outboxHealth() {
    return getApiV1SystemOutboxHealth(this.client);
  }

  testEvent() {
    return postApiV1SystemTestEvent(this.client);
  }

  testNotification() {
    return postApiV1SystemTestNotification(this.client);
  }
}
